import { render, staticRenderFns } from "./ProjectImport.vue?vue&type=template&id=f2bfd9d8"
import script from "./ProjectImport.vue?vue&type=script&lang=js"
export * from "./ProjectImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports